// По ТЗ 03.09.2026 (встреча по Сакшы, распорядок дня): 17 типов активностей
// с приоритетами. Служба > сон > остальное. `abbr` — 2-3 буквы для маленькой
// ячейки, `icon` — эмодзи для крупной, `pattern` — CSS-класс для ч/б печати
// (в стилях DailyScheduleView).

export const SLOT_MINUTES = 30
export const START_HOUR = 20                          // сутки 20:00 → 20:00
export const SLOTS_PER_DAY = 24 * 60 / SLOT_MINUTES   // 48
export const SLEEP_MIN_MINUTES = 8 * 60               // обязательно 8 часов
export const SLEEP_BLOCK_MINUTES = 4 * 60             // 2 блока по 4 часа

// Приоритет: чем больше — тем сильнее перекрывает.
// Формула распределения: сортируем правила по возрастанию приоритета и
// накладываем на сетку слева направо — верхние затираются нижними.
// По ТЗ 09.09.2026 (обратная связь пользователя): оставляем 5 базовых
// активностей + сон. Остальные типы (personal/tv/chores/bath/edu_work/
// maintenance/training/sport/morning_check/staff_meeting/evening_walk/
// prep_duty) убраны из UI — если попадутся в сохранённых слотах, ячейка
// просто останется пустой (activityStyle вернёт null).
export const ACTIVITIES = {
  meal:  { priority: 40,  abbr: 'Ед',  icon: '😊', color: '#FEF3C7', text: '#78350F', pattern: 'meal',  i18n: 'chpo.daily.act.meal' },
  pfz:   { priority: 45,  abbr: 'УФЗ', icon: '🏃', color: '#DBEAFE', text: '#1E3A8A', pattern: 'pfz',   i18n: 'chpo.daily.act.pfz' },
  rally: { priority: 60,  abbr: 'БР',  icon: '⭐', color: '#FECACA', text: '#7F1D1D', pattern: 'rally', i18n: 'chpo.daily.act.rally' },
  sleep: { priority: 80,  abbr: 'Сн',  icon: '💤', color: '#D1D5DB', text: '#111827', pattern: 'sleep', i18n: 'chpo.daily.act.sleep' },
  duty:  { priority: 100, abbr: 'Сл',  icon: '➤', color: '#86EFAC', text: '#14532D', pattern: 'duty',  i18n: 'chpo.daily.act.duty' },
}

export function activityLabel(kind, i18n) {
  const cfg = ACTIVITIES[kind]
  if (!cfg) return kind || ''
  return i18n ? i18n.t(cfg.i18n) : cfg.i18n
}

export function activityStyle(kind) {
  return ACTIVITIES[kind] || null
}

// «HH:MM» → минут от полуночи. «24:00» = 1440.
export function parseHHMM(str) {
  if (!str) return null
  const m = String(str).match(/^(\d{1,2}):(\d{2})/)
  if (!m) return null
  const h = Number(m[1]), mm = Number(m[2])
  if (!Number.isFinite(h) || !Number.isFinite(mm)) return null
  return h * 60 + mm
}

// Абсолютные минуты от 20:00 сегодня (0..1440).
// Если время < 20:00 — трактуем как «завтра» (+ (24-20)*60 = +240).
export function absFrom20(str) {
  const mins = parseHHMM(str)
  if (mins == null) return null
  if (mins >= START_HOUR * 60) return mins - START_HOUR * 60
  return mins + (24 - START_HOUR) * 60
}

// [start, end) в минутах от 20:00. end==start → 24ч наряд.
export function rangeAbs(startStr, endStr) {
  const s = absFrom20(startStr)
  let e = absFrom20(endStr)
  if (s == null || e == null) return null
  if (e <= s) e += 24 * 60
  return [s, Math.min(e, 24 * 60)]
}

// Абс. минуты слота idx = START_HOUR*60 + idx*30
export function slotAbsMinutes(idx) { return START_HOUR * 60 + idx * SLOT_MINUTES }

// Форматирование "HH:MM" из абс. минут (от полуночи).
export function fmtHHMM(mins) {
  const m = ((mins % 1440) + 1440) % 1440
  const h = Math.floor(m / 60), mm = m % 60
  return `${String(h).padStart(2, '0')}:${String(mm).padStart(2, '0')}`
}
